module.exports = __webpack_public_path__ + "static/img/nh_text.6350a99f.png";